<template>
    <flex-container
        v-for="(faq, index) in props.faqs"
        :key="index"
        :gap="0"
    >
        <card-normal
            :border-color="isSelected(index) ? 'primary' : 'gray-400'"
            :background-color="isSelected(index) ? 'white' : 'gray-200'"
        >
            <div class="faq-list">
                <div>
                    <flex-container align-content="center">
                        <text-decorator v-if="!isSelected(index)" bold>
                            {{ faq.question }}
                        </text-decorator>
                        <flex-container v-else>
                            <input-group v-model="faq.question">
                                <template #input>
                                    <text-input />
                                </template>
                            </input-group>
                        </flex-container>
                        <flex-container>
                            <text-decorator v-if="!isSelected(index)">
                                {{ faq.answer }}
                            </text-decorator>
                            <flex-container v-else>
                                <input-group v-model="faq.answer">
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                </div>
                <div>
                    <flex-container
                        direction="column"
                        align-content="center"
                        justify-items="between"
                        :gap="Size.lg"
                    >
                        <button-plain-icon
                            v-if="!isSelected(index)"
                            :icon="EditSquareIcon"
                            is-custom-icon
                            @click="editIndex = index"
                        />
                        <button-plain-icon
                            v-else
                            :icon="CheckIcon"
                            :color="'green-500'"
                            is-custom-icon
                            @click="saveFaq"
                        />
                        <button-plain-icon
                            :icon="DeleteIcon"
                            :color="'red-500'"
                            is-custom-icon
                            @click="deleteFaq(index)"
                        />
                    </flex-container>
                </div>
            </div>
        </card-normal>
    </flex-container>
</template>

<script setup lang="ts">
    import CheckIcon from '@keyvue/one-awesome-icons/icons/regular/check.svg?component';
    import DeleteIcon from '@keyvue/one-material-icons/icons/delete.svg?component';
    import type { Faq } from '@keyvue/one-api-client';
    import EditSquareIcon from '@keyvue/one-material-icons/icons/edit.svg?component';
    import { Size } from '@keyvue/one-ui';
    import { computed, ref } from 'vue';

    interface Props {
        faqs: Faq[]
    }

    const props = defineProps<Props>();

    const emit = defineEmits<{
        (e: 'delete:faq', value: number): void;
        (e: 'save:faq'): void;
    }>();

    const editIndex = ref<number | null>(null);
    const isSelected = computed(() => (index: number) => editIndex.value === index);

    function deleteFaq(index: number): void {
        if (editIndex.value === index) {
            editIndex.value = null;
        }
        emit('delete:faq', index);
    }

    function saveFaq(): void {
        editIndex.value = null;
        emit('save:faq');
    }
</script>

<style scoped lang="scss">
.faq-list {
    display: grid;
    grid-template-columns: 10fr 1fr;
    justify-content: center;
    align-items: center;
}
</style>
